<div class="app-text-area f-control" [ngClass]="{ 'with-label': !!label }">
  <mat-label *ngIf="label" class="label"
    >{{ label }}:
    <ng-container *ngIf="isRequired">*</ng-container>
  </mat-label>

  <mat-form-field
    [ngClass]="{ 'mat-form-field-invalid': highlightAsError, readonly: readonly }"
    appearance="outline"
  >
    <textarea
      matInput
      matNativeControl
      [formControl]="control"
      [readonly]="readonly"
      [placeholder]="placeholder"
      [name]="name"
      [id]="id"
      class="form-control multiline"
      [rows]="rowsCount"
      (input)="onInputChange($event)"
    ></textarea>
  </mat-form-field>

  <span
    *ngIf="showCounter"
    [ngClass]="{ 'error-text': control && control.invalid && control.touched }"
    class="counter"
  >
    {{ counter }}
  </span>

  <mat-error class="errors" *ngIf="showErrors && control?.invalid && control?.touched"
    >{{ getErrorMessage() }}
  </mat-error>
</div>
